export const MAX_USER_PRICE = 10 ** 8; // 100 million
